import {Check} from '@sparkware/app-utils';


export class CssClassNameBuilder {
  _classes: string[] = [];
  append(...classes): this {

    classes.forEach(item => {
      if(Check.isString(item)) {
        this._classes.push(item);
      } else if(Check.isArray(item)) {
        item.forEach(c => this._classes.push(String(c)));
      } else if (Check.isNullOrUndefined(item)) {
        // just ignore it
      } else {
        throw new Error('append method accepts only string or string[] as argument');
      }
    });
    return this;
  }

  build() {
    let result = this._classes.reduce((acc, curr) => acc + ' ' + curr, '');
    return result.substring(1, result.length);
  }
}


